import { Map, fromJS } from 'immutable';
import { getFeature } from './actions';

import {
  FEATURE_NEW_CART_API_ACCOUNTS,
  FEATURE_ADDRESS_V2_ACCOUNTS,
  SEC_ACCOUNTS,
  MULTIPLE_FUTURES_ACCOUNTS
} from './constants';

export const DEFAULT_FEATURE_STATE = Map({
  [FEATURE_NEW_CART_API_ACCOUNTS]: [],
  [FEATURE_ADDRESS_V2_ACCOUNTS]: [],
  [SEC_ACCOUNTS]: [],
  [MULTIPLE_FUTURES_ACCOUNTS]: []
});

const formatResponse = (key, response) => {
  switch (key) {
    case FEATURE_NEW_CART_API_ACCOUNTS:
      return response.map(value => value.toString());

    default:
      return response;
  }
};

const feature = (state = DEFAULT_FEATURE_STATE, { type, payload }) => {
  const newState = fromJS(state);

  switch (type) {
    case getFeature.event.success:
      return newState.set(payload.featureKey, formatResponse(payload.featureKey, payload.response));

    default:
      return state;
  }
};

export default feature;
